// Number formatting used across the redesign. Keeps sign conventions in one place.

export function fmtMoney(n, currency = 'USD', digits = 0) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  try {
    return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    }).format(Number(n));
  } catch (e) {
    return `${Number(n).toFixed(digits)}`;
  }
}

export function fmtSignedMoney(n, currency = 'USD', digits = 0) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  return `${v > 0 ? '+' : v < 0 ? '−' : ''}${fmtMoney(Math.abs(v), currency, digits)}`;
}

// fmtPct(3.456) -> "+3.5%", fmtPct(-1.9, {digits: 1}) -> "−1.9%"
export function fmtPct(n, { digits = 1, sign = true } = {}) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  const body = `${Math.abs(v).toFixed(digits)}%`;
  if (!sign) return `${v < 0 ? '−' : ''}${body}`;
  return `${v > 0 ? '+' : v < 0 ? '−' : ''}${body}`;
}

export function fmtNum(n, digits = 2) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits });
}

export function signClass(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v === 0) return '';
  return v > 0 ? 'dd-gain' : 'dd-loss';
}
